import Vue from 'vue';

import apiTerms from '@src/api/terms';
import { ROUTE_DICTIONARY } from '@src/routes';

export default {
  state: {
    currentRequest: '',
    currentChoice: '',
    requestsHistory: {},
    termsHistory: {},
    termLoading: false,
    termError: ''
  },

  getters: {
    currentRequest: state => state.currentRequest,
    currentChoice: state => state.currentChoice,
    currentTerms: state =>
      state.currentRequest && state.requestsHistory[state.currentRequest]
        ? state.requestsHistory[state.currentRequest].map(i =>
            Object.assign({}, i)
          )
        : [],
    currentTermInfo: state =>
      state.currentChoice && state.termsHistory[state.currentChoice]
        ? JSON.parse(JSON.stringify(state.termsHistory[state.currentChoice]))
        : {},
    termInfoLoading: state => state.termLoading,
    termInfoError: state => state.termError
  },

  mutations: {
    SET_CURRENT_REQUEST(state, str) {
      state.currentRequest = str;
    },
    SET_CURRENT_CHOICE(state, str) {
      state.currentChoice = str;
    },
    SET_REQUESTS_HISTORY_ITEM(state, obj) {
      Vue.set(state.requestsHistory, obj.name, obj.terms);
    },
    SET_TERMS_HISTORY_ITEM(state, obj) {
      Vue.set(state.termsHistory, obj.name, obj.info);
    },
    SET_TERM_INFO_LOADING(state, status) {
      state.termLoading = status;
    },
    SET_TERM_INFO_ERROR(state, message) {
      state.termError = message;
    }
  },

  actions: {
    async getDictionaryList({ state, commit }, str) {
      try {
        if (str && !(str in state.requestsHistory)) {
          const terms = await apiTerms.findTerms(str);
          commit('SET_REQUESTS_HISTORY_ITEM', {
            name: str,
            terms: terms
          });
        }
        commit('SET_CURRENT_REQUEST', str);
      } catch (err) {
        console.error(
          'Error on get dictionary list: ',
          err.message ? err.message : err
        );
      }
    },
    async getDictionaryItemInfo({ state, commit }, str) {
      commit('SET_TERM_INFO_LOADING', true);
      commit('SET_TERM_INFO_ERROR', '');
      try {
        if (str && !(str in state.termsHistory)) {
          const info = await apiTerms.getTermInfo(str);

          commit('SET_TERMS_HISTORY_ITEM', {
            name: str,
            info: info
          });
        }
        commit('SET_CURRENT_CHOICE', str);
      } catch (err) {
        if (apiTerms.isErrorNotFound(err)) {
          commit(
            'SET_TERM_INFO_ERROR',
            `Описание термина "${str}" не найдено.`
          );
          commit('SET_TERMS_HISTORY_ITEM', {
            name: str,
            info: `Описание термина "${str}" не найдено.`
          });
          commit('SET_CURRENT_CHOICE', str);
        } else if (!apiTerms.isErrorCancel(err)) {
          commit(
            'SET_TERM_INFO_ERROR',
            `Ошибка №${
              err.response.status
            } при запросе к серверу. Обратитесь к администратру.`
          );
        }
        console.error(
          'Error on get dictionary item info: ',
          err.message ? err.message : err
        );
      } finally {
        commit('SET_TERM_INFO_LOADING', false);
      }
    }
  }
};
